import {Button, Card, Col, Form, Row} from "react-bootstrap";
import React, {useState} from "react";
import {RequireAuth} from "../../Components/Security/RequireAuth";
import {DefaultContainer} from "../Shared/DefaultContainer";
import {FormLabelRequiredAsterisk} from "../../Components/Form/FormLabelRequiredAsterisk";
import {FileUpload} from "../../Components/FileUpload/FileUpload";
import {useMutation} from "react-query";
import {appLoading} from "../../Store/loadingSlice";
import {ErrorMessageBuilder} from "../../Services/Notificator/ErrorMessageBuilder";
import {Notificator} from "../../Services/Notificator/Notificator";
import {useAppDispatch} from "../../hooks";
import {uploadFinanceFile} from "../../Api/Mutation/Finance";

export const FinanceImportView: React.FC = () => {

    const ALLOWED_SEPA_XML_FILETYPES = [
        "application/vnd.ms-excel",
        "application/vnd.ms-excel.sheet.macroEnabled.12",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ]
    const [dropzoneFiles, setDropzoneFiles] = useState<any>([])
    const dispatch = useAppDispatch()
    const [errors, setErrors] = useState<string>('')

    const TEMPLATE_URL = process.env.REACT_APP_FRONTEND_URL + "plantilla-financiero.xlsx"

    const uploadMutation = useMutation({
        mutationFn: (body: any) => uploadFinanceFile(body.file),
        onMutate: (body: any) => {
            dispatch(
                appLoading({
                    value: true,
                    text: `Processando archivo: ${body.file.name} ...`
                })
            )
        },
        onError: (error: any) => {
            dispatch(appLoading({value: false}))

            const notificationMessage = ErrorMessageBuilder.create(error)
            Notificator.error(notificationMessage, 'Error')
        },
        onSuccess: (response: any) => {
            setDropzoneFiles([])
            dispatch(appLoading({value: false}))

            const data = response.data?._result ?? [];

            if(data.errors.length){
                setErrors(data.errors.join("\n"))
                Notificator.warning('Los datos se han importado con errores.')
            }else{
                Notificator.success('Los gastos se han importado correctamente')
            }
        }
    })

    return (
        <RequireAuth>
            <DefaultContainer>
                <Col id={"mainRequestList"}>

                    <Row>
                        <Col xs={12} lg={6} className={""}>
                            <h1 className={"pb-lg-4"}>Importar datos financieros</h1>
                        </Col>
                        <Col xs={12} lg={6} className={"mb-4 mb-lg-0 text-lg-end"}>
                            <Button
                                className={"purple-btn btn btn-primary"}
                                href={TEMPLATE_URL}
                            >Plantilla de datos financieros</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Card className={"px-0 mx-2 my-2"}>
                            <Card.Body>

                                {
                                    errors && errors.length > 0 &&
                                    <div className={"alert alert-warning"}>
                                        <strong>Errores:</strong>
                                        <pre>{errors}</pre>
                                    </div>
                                }

                                {
                                    uploadMutation.isError &&
                                    <div className={"alert alert-danger"}>
                                        <strong>Error al importar el archivo.</strong>
                                        <p>Comprueba que el archivo es correcto y que no contiene errores.</p>
                                    </div>
                                }

                                <Form.Group controlId={"financeFile"}>
                                    <Form.Label>
                                        Adjunta el archivo excel &nbsp;<FormLabelRequiredAsterisk/>
                                    </Form.Label>
                                    <FileUpload
                                        defaultFiles={dropzoneFiles}
                                        onChange={(files) => setDropzoneFiles(files)}
                                        acceptedMimmeTypes={ALLOWED_SEPA_XML_FILETYPES.join(",")}
                                        allowedFilesText={"Solo se admite el archivo excel de la plantilla con los datos financieros."}
                                        maxFiles={1}
                                    />
                                </Form.Group>
                            </Card.Body>
                            <Card.Footer className={"text-end"}>
                                <Button
                                    className={"purple-btn btn btn-primary"}
                                    disabled={dropzoneFiles.length === 0}
                                    onClick={() => {
                                        const files = dropzoneFiles

                                        if (typeof files[0] === 'undefined') {
                                            return
                                        }

                                        const file = files[0]

                                        if (!file.valid) {
                                            Notificator.error('Archivo inválido')
                                            return
                                        }

                                        uploadMutation.mutate({
                                            file: file.file,
                                        })
                                    }}
                                >Importar</Button>
                            </Card.Footer>
                        </Card>
                    </Row>

                </Col>
            </DefaultContainer>
        </RequireAuth>
    )
}

